module.exports = __webpack_public_path__ + "static/media/pe.f0816c37.svg";